import React from 'react';
import { Stack } from '@piwikpro/ui-components';
import { formatTime } from '../helpers';
import { useAppSelector } from '../hooks';
import { selectFutureMaintenance } from '../incidentSlice';
import { Incident, IncidentComment } from '../model';
import { severity2icon, severity2msg } from '../helpers';

const MaintenanceInfo: React.FC = () => {
  const mntc = useAppSelector(selectFutureMaintenance);
  if (mntc.length === 0) return null;
  const plannedOngoingMsg = (v: Incident) =>
    v.getHoursSinceStart(new Date()) < 0 ? 'Planned ' : 'Ongoing ';
  return (
    <>
      {mntc.map((v: Incident) => (
        <>
          <Stack key={v.id} verticalAlignment="center" spacing="default">
            <Stack.Item>
              <div className="m-4">{severity2icon.maintenance}</div>
            </Stack.Item>
            <Stack.Item>
              <strong>{plannedOngoingMsg(v) + severity2msg.maintenance}</strong>{' '}
              : {formatTime(v)}
            </Stack.Item>
          </Stack>
          {v.details.map((i: IncidentComment) => (
            <Stack wrap={true}>
              <div className="m-1">{i.text}</div>
            </Stack>
          ))}
        </>
      ))}
    </>
  );
};

export { MaintenanceInfo };
